import React, { useEffect, useState, useRef } from "react";
import "cropperjs/dist/cropper.css";
import Cropper from "cropperjs";
import Usercard from "../../components/Usercard";
import api, { baseURL } from "../../Axios";
import {
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  Table,
  TabPane,
} from "reactstrap";

const Approvel = () => {
  const [houseVeri, setHouseVeri] = useState([]);
  const [multiImageVeri, setMultiImageVeri] = useState([]);
  const [aboutmyVeri, setAboutmyVeri] = useState([]);
  const [aboutfamilyVeri, setAboutfamilyVeri] = useState([]);
  const [expectingVeri, setExpectingVeri] = useState([]);

  const [activeTab, setActiveTab] = useState("1");

  /** Fetch multi images on tab switch */
  useEffect(() => {
    if (activeTab === "1") {
      fetchMultiImages();
    } else if (activeTab === "2") {
      fetchHouseVerification();
    }
  }, [activeTab]);

  const fetchAboutMe = async () => {
    try {
      const res = await api.get("/admin/approvals/notVerified", {
        params: { type: 2 },
      });
      setAboutmyVeri(res.data.data);
    } catch (err) {
      console.error("Error fetching image verification:", err);
    }
  };

  const fetchAboutFamily = async () => {
    try {
      const res = await api.get("/admin/approvals/notVerified", {
        params: { type: 1 },
      });
      setAboutfamilyVeri(res.data.data);
    } catch (err) {
      console.error("Error fetching image verification:", err);
    }
  };

  const fetchExpecting = async () => {
    try {
      const res = await api.get("/admin/approvals/notVerified", {
        params: { type: 3 },
      });
      setExpectingVeri(res.data.data);
    } catch (err) {
      console.error("Error fetching image verification:", err);
    }
  };

  const fetchHouseVerification = async () => {
    try {
      const res = await api.get("/admin/approvals/housePicNotVerified");
      setHouseVeri(res.data.data);
    } catch (err) {
      console.error("Error fetching house verification:", err);
    }
  };

  const fetchMultiImages = async () => {
    try {
      const res = await api.get("/admin/approvals/multipleImageNotVerified");
      setMultiImageVeri(res.data.data || []);
    } catch (err) {
      console.error("Error fetching multiple images:", err);
    }
  };

  function deletee(i) {
    api.post("/admin/manageuserProfile/terminateUser", { id: i.id });
  }
  function activeinactive(i) {
    api.post("/admin/manageuserProfile/deleteUser", { id: i.id });
  }
  const [fetchedTabs, setFetchedTabs] = useState({});

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);

    if (!fetchedTabs[tabId]) {
      switch (tabId) {
        case "1":
          fetchMultiImages();
          break;
        case "2":
          fetchHouseVerification();
          break;
        case "3":
          fetchAboutMe();
          break;
        case "4":
          fetchAboutFamily();
          break;
        case "5":
          fetchExpecting();
          break;

        default:
          break;
      }
      setFetchedTabs((prev) => ({ ...prev, [tabId]: true }));
    }
  };

  return (
    <div className="col-12">
      <Row>
        <Col xs={12}>
          <div className="page-title">
            <h1 className="title">New Members Approvals</h1>
          </div>
          <section className="box">
            <div style={{ padding: "25px", backgroundColor: "white" }}>
              <Nav tabs style={{ display: "flex", flexWrap: "wrap" }}>
                <NavItem style={{ flex: "1 0 12.5%", textAlign: "center" }}>
                  <NavLink
                    style={{ padding: "5px 10px" }}
                    className={activeTab === "1" ? "active" : ""}
                    onClick={() => handleTabClick("1")}
                  >
                    Multiple Image Verification
                  </NavLink>
                </NavItem>
                <NavItem style={{ flex: "1 0 12.5%", textAlign: "center" }}>
                  <NavLink
                    style={{ padding: "5px 10px" }}
                    className={activeTab === "2" ? "active" : ""}
                    onClick={() => handleTabClick("2")}
                  >
                    House Image Verification
                  </NavLink>
                </NavItem>{" "}
                <NavItem style={{ flex: "1 0 12.5%", textAlign: "center" }}>
                  <NavLink
                    style={{ padding: "5px 10px" }}
                    className={activeTab === "3" ? "active" : ""}
                    onClick={() => handleTabClick("3")}
                  >
                    About My Self verification
                  </NavLink>
                </NavItem>
                <NavItem style={{ flex: "1 0 12.5%", textAlign: "center" }}>
                  <NavLink
                    style={{ padding: "5px 10px" }}
                    className={activeTab === "4" ? "active" : ""}
                    onClick={() => handleTabClick("4")}
                  >
                    About family verification
                  </NavLink>
                </NavItem>{" "}
                <NavItem style={{ flex: "1 0 12.5%", textAlign: "center" }}>
                  <NavLink
                    style={{ padding: "5px 10px" }}
                    className={activeTab === "5" ? "active" : ""}
                    onClick={() => handleTabClick("5")}
                  >
                    Expecting verification
                  </NavLink>
                </NavItem>
                {/* <NavItem style={{ flex: "1 0 12.5%", textAlign: "center" }}>
                  <NavLink
                    style={{ padding: "5px 10px" }}
                    className={activeTab === "7" ? "active" : ""}
                    onClick={() => handleTabClick("7")}
                  >
                    Verified Members List
                  </NavLink>
                </NavItem> */}
              </Nav>

              <TabContent activeTab={activeTab} className="pt-4">
                {/* IMAGE VERIFICATION */}
                <TabPane tabId="1">
                  <Row>
                    <div>
                      <h5>Multiple Image Verification:</h5>
                      <Row>
                        {Array.isArray(multiImageVeri) &&
                        multiImageVeri.length > 0 ? (
                          multiImageVeri.map((user, index) => {
                            return (
                              <Usercard
                                key={index}
                                id={user.id}
                                profileId={user.profileId}
                                name={user.userName}
                                image={user.profilePic}
                                age={user.age}
                                gender={user.gender}
                                taluk={user.taluk}
                                district={user.district}
                                dob={user.dob}
                                state={user.state}
                                status={user.status}
                                onActive={() => activeinactive(user)}
                                onDelete={() => deletee(user)}
                              />
                            );
                          })
                        ) : (
                          <div
                            style={{ marginLeft: "500px", marginTop: "250px" }}
                          >
                            <h3> Profile Not Found</h3>
                          </div>
                        )}{" "}
                      </Row>
                    </div>
                  </Row>
                </TabPane>
                {/* Other Tabs */}
                <TabPane tabId="2">
                  {" "}
                  <Row>
                    {Array.isArray(houseVeri) && houseVeri.length > 0 ? (
                      houseVeri.map((user, index) => {
                        return (
                          <Usercard
                            key={index}
                            id={user.id}
                            profileId={user.profileId}
                            name={user.userName}
                            image={user.profilePic}
                            age={user.age}
                            gender={user.gender}
                            taluk={user.taluk}
                            district={user.district}
                            dob={user.dob}
                            state={user.state}
                            status={user.status}
                            onActive={() => activeinactive(user)}
                            onDelete={() => deletee(user)}
                          />
                        );
                      })
                    ) : (
                      <div style={{ marginLeft: "500px", marginTop: "250px" }}>
                        <h3> Profile Not Found</h3>
                      </div>
                    )}{" "}
                  </Row>
                </TabPane>
                <TabPane tabId="3">
                  <Row>
                    {" "}
                    {Array.isArray(aboutmyVeri) && aboutmyVeri.length > 0 ? (
                      aboutmyVeri.map((user, index) => {
                        return (
                          <Usercard
                            key={index}
                            id={user.id}
                            profileId={user.profileId}
                            name={user.userName}
                            image={user.profilePic}
                            age={user.age}
                            gender={user.gender}
                            taluk={user.taluk}
                            district={user.district}
                            dob={user.dob}
                            state={user.state}
                            status={user.status}
                            onActive={() => activeinactive(user)}
                            onDelete={() => deletee(user)}
                          />
                        );
                      })
                    ) : (
                      <div style={{ marginLeft: "500px", marginTop: "250px" }}>
                        <h3> Profile Not Found</h3>
                      </div>
                    )}{" "}
                  </Row>
                </TabPane>
                <TabPane tabId="4">
                  <Row>
                    {" "}
                    {Array.isArray(aboutfamilyVeri) &&
                    aboutfamilyVeri.length > 0 ? (
                      aboutfamilyVeri.map((user, index) => {
                        return (
                          <Usercard
                            key={index}
                            id={user.id}
                            profileId={user.profileId}
                            name={user.userName}
                            image={user.profilePic}
                            age={user.age}
                            gender={user.gender}
                            taluk={user.taluk}
                            district={user.district}
                            dob={user.dob}
                            state={user.state}
                            status={user.status}
                            onActive={() => activeinactive(user)}
                            onDelete={() => deletee(user)}
                          />
                        );
                      })
                    ) : (
                      <div style={{ marginLeft: "500px", marginTop: "250px" }}>
                        <h3> Profile Not Found</h3>
                      </div>
                    )}{" "}
                  </Row>
                </TabPane>{" "}
                <TabPane tabId="5">
                  <Row>
                    {" "}
                    {Array.isArray(expectingVeri) &&
                    expectingVeri.length > 0 ? (
                      expectingVeri.map((user, index) => {
                        return (
                          <Usercard
                            key={index}
                            id={user.id}
                            profileId={user.profileId}
                            name={user.userName}
                            image={user.profilePic}
                            age={user.age}
                            gender={user.gender}
                            taluk={user.taluk}
                            district={user.district}
                            dob={user.dob}
                            state={user.state}
                            status={user.status}
                            onActive={() => activeinactive(user)}
                            onDelete={() => deletee(user)}
                          />
                        );
                      })
                    ) : (
                      <div style={{ marginLeft: "500px", marginTop: "250px" }}>
                        <h3> Profile Not Found</h3>
                      </div>
                    )}{" "}
                  </Row>
                </TabPane>
              </TabContent>
            </div>
          </section>
        </Col>
      </Row>
    </div>
  );
};

export default Approvel;
